import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { setFilter, resetFilter } from "../actions/millActions";
import { toggleFilter } from "../actions/settingActions";

import { ReactComponent as FilterIcon } from "../icons/filter_alt.svg";

import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Badge from "@material-ui/core/Badge";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";

const styles = (theme) => ({
  drawer: {
    position: "absolute",
    padding: "20px 27px 0px 27px",
    maxHeight: "calc(100% - (66px * 3))",
    top: "66px",
  },
  label: {
    margin: 0,
    marginLeft: "-8px",
    marginTop: "-8px",
  },
  img: {
    maxWidth: "20px",
    marginRight: "5px",
  },
  badge: {
    marginRight: "5px",
    marginTop: "5px",
  },
  button: {
    width: "max-content",
    float: "right",
    marginLeft: "10px",
  },
  tooltip: {
    backgroundColor: "white",
    color: "#00568E",
    fontSize: "9pt",
    border: "1px solid #00568E",
  },
});

class Filter extends Component {
  filterCount = (property, value) => {
    return this.props.mills.features.filter(
      (mill) =>
        mill.properties[property] === value &&
        (this.props.municipality.length > 0
          ? this.props.municipality.includes(mill.properties.Gemeinde)
          : true) &&
        (this.props.propulsion.length > 0
          ? this.props.propulsion.includes(mill.properties.Antriebsart)
          : true) &&
        (this.props.exists.length > 0
          ? this.props.exists.includes(mill.properties.GebäudeVorhanden)
          : true)
    ).length;
  };

  render() {
    const filterCount =
      this.props.municipality.length +
      this.props.propulsion.length +
      this.props.exists.length;
    const mills = this.props.mills.features;
    return (
      <div>
        <Tooltip
          title="Filter einstellen"
          classes={{
            tooltip: this.props.classes.tooltip,
          }}
        >
          <IconButton
            color="inherit"
            onClick={
              this.props.open
                ? () => this.props.toggleFilter(false)
                : () => this.props.toggleFilter(true)
            }
            style={{ padding: 0, marginRight: "15px" }}
            className={"filter-button"}
          >
            <Badge
              classes={{ badge: this.props.classes.badge }}
              badgeContent={filterCount}
              invisible={filterCount === 0}
              color="secondary"
            >
              <FilterIcon />
            </Badge>
          </IconButton>
        </Tooltip>
        <Drawer
          anchor={"top"}
          open={this.props.open}
          onClose={() => this.props.toggleFilter(false)}
          classes={{ paperAnchorTop: this.props.classes.drawer }}
          className={"filter-div"}
        >
          {mills ? (
            <Grid container spacing={3}>
              <Grid item sm={4} xs={12}>
                Gemeinde
                <FormGroup style={{ paddingTop: "8px" }}>
                  <FormControlLabel
                    classes={{ root: this.props.classes.label }}
                    control={
                      <Switch
                        color="primary"
                        checked={this.props.municipality.includes("Buende")}
                        onChange={(e) =>
                          this.props.setFilter(
                            "municipality",
                            e.target.name,
                            e.target.checked
                          )
                        }
                        name="Buende"
                      />
                    }
                    label={
                      <div style={{ display: "flex" }}>
                        <div>Bünde</div>
                        <div
                          style={{
                            fontSize: "13px",
                            lineHeight: "24px",
                            marginLeft: "4px",
                            fontStyle: "italic",
                          }}
                        >
                          ({this.filterCount("Gemeinde", "Buende")})
                        </div>
                      </div>
                    }
                  />
                  <FormControlLabel
                    classes={{ root: this.props.classes.label }}
                    control={
                      <Switch
                        color="primary"
                        checked={this.props.municipality.includes("Enger")}
                        onChange={(e) =>
                          this.props.setFilter(
                            "municipality",
                            e.target.name,
                            e.target.checked
                          )
                        }
                        name="Enger"
                      />
                    }
                    label={
                      <div style={{ display: "flex" }}>
                        <div>Enger</div>
                        <div
                          style={{
                            fontSize: "13px",
                            lineHeight: "24px",
                            marginLeft: "4px",
                            fontStyle: "italic",
                          }}
                        >
                          ({this.filterCount("Gemeinde", "Enger")})
                        </div>
                      </div>
                    }
                  />
                  <FormControlLabel
                    classes={{ root: this.props.classes.label }}
                    control={
                      <Switch
                        color="primary"
                        checked={this.props.municipality.includes("Herford")}
                        onChange={(e) =>
                          this.props.setFilter(
                            "municipality",
                            e.target.name,
                            e.target.checked
                          )
                        }
                        name="Herford"
                      />
                    }
                    label={
                      <div style={{ display: "flex" }}>
                        <div>Herford</div>
                        <div
                          style={{
                            fontSize: "13px",
                            lineHeight: "24px",
                            marginLeft: "4px",
                            fontStyle: "italic",
                          }}
                        >
                          ({this.filterCount("Gemeinde", "Herford")})
                        </div>
                      </div>
                    }
                  />
                  <FormControlLabel
                    classes={{ root: this.props.classes.label }}
                    control={
                      <Switch
                        color="primary"
                        checked={this.props.municipality.includes(
                          "Hiddenhausen"
                        )}
                        onChange={(e) =>
                          this.props.setFilter(
                            "municipality",
                            e.target.name,
                            e.target.checked
                          )
                        }
                        name="Hiddenhausen"
                      />
                    }
                    label={
                      <div style={{ display: "flex" }}>
                        <div>Hiddenhausen</div>
                        <div
                          style={{
                            fontSize: "13px",
                            lineHeight: "24px",
                            marginLeft: "4px",
                            fontStyle: "italic",
                          }}
                        >
                          ({this.filterCount("Gemeinde", "Hiddenhausen")})
                        </div>
                      </div>
                    }
                  />
                  <FormControlLabel
                    classes={{ root: this.props.classes.label }}
                    control={
                      <Switch
                        color="primary"
                        checked={this.props.municipality.includes(
                          "Kirchlengern"
                        )}
                        onChange={(e) =>
                          this.props.setFilter(
                            "municipality",
                            e.target.name,
                            e.target.checked
                          )
                        }
                        name="Kirchlengern"
                      />
                    }
                    label={
                      <div style={{ display: "flex" }}>
                        <div>Kirchlengern</div>
                        <div
                          style={{
                            fontSize: "13px",
                            lineHeight: "24px",
                            marginLeft: "4px",
                            fontStyle: "italic",
                          }}
                        >
                          ({this.filterCount("Gemeinde", "Kirchlengern")})
                        </div>
                      </div>
                    }
                  />
                  <FormControlLabel
                    classes={{ root: this.props.classes.label }}
                    control={
                      <Switch
                        color="primary"
                        checked={this.props.municipality.includes("Loehne")}
                        onChange={(e) =>
                          this.props.setFilter(
                            "municipality",
                            e.target.name,
                            e.target.checked
                          )
                        }
                        name="Loehne"
                      />
                    }
                    label={
                      <div style={{ display: "flex" }}>
                        <div>Löhne</div>
                        <div
                          style={{
                            fontSize: "13px",
                            lineHeight: "24px",
                            marginLeft: "4px",
                            fontStyle: "italic",
                          }}
                        >
                          ({this.filterCount("Gemeinde", "Loehne")})
                        </div>
                      </div>
                    }
                  />
                  <FormControlLabel
                    classes={{ root: this.props.classes.label }}
                    control={
                      <Switch
                        color="primary"
                        checked={this.props.municipality.includes(
                          "Roedinghausen"
                        )}
                        onChange={(e) =>
                          this.props.setFilter(
                            "municipality",
                            e.target.name,
                            e.target.checked
                          )
                        }
                        name="Roedinghausen"
                      />
                    }
                    label={
                      <div style={{ display: "flex" }}>
                        <div>Rödinghausen</div>
                        <div
                          style={{
                            fontSize: "13px",
                            lineHeight: "24px",
                            marginLeft: "4px",
                            fontStyle: "italic",
                          }}
                        >
                          ({this.filterCount("Gemeinde", "Roedinghausen")})
                        </div>
                      </div>
                    }
                  />
                  <FormControlLabel
                    classes={{ root: this.props.classes.label }}
                    control={
                      <Switch
                        color="primary"
                        checked={this.props.municipality.includes("Spenge")}
                        onChange={(e) =>
                          this.props.setFilter(
                            "municipality",
                            e.target.name,
                            e.target.checked
                          )
                        }
                        name="Spenge"
                      />
                    }
                    label={
                      <div style={{ display: "flex" }}>
                        <div>Spenge</div>
                        <div
                          style={{
                            fontSize: "13px",
                            lineHeight: "24px",
                            marginLeft: "4px",
                            fontStyle: "italic",
                          }}
                        >
                          ({this.filterCount("Gemeinde", "Spenge")})
                        </div>
                      </div>
                    }
                  />
                  <FormControlLabel
                    classes={{ root: this.props.classes.label }}
                    control={
                      <Switch
                        color="primary"
                        checked={this.props.municipality.includes("Vlotho")}
                        onChange={(e) =>
                          this.props.setFilter(
                            "municipality",
                            e.target.name,
                            e.target.checked
                          )
                        }
                        name="Vlotho"
                      />
                    }
                    label={
                      <div style={{ display: "flex" }}>
                        <div>Vlotho</div>
                        <div
                          style={{
                            fontSize: "13px",
                            lineHeight: "24px",
                            marginLeft: "4px",
                            fontStyle: "italic",
                          }}
                        >
                          ({this.filterCount("Gemeinde", "Vlotho")})
                        </div>
                      </div>
                    }
                  />
                </FormGroup>
              </Grid>
              <Grid item sm={4} xs={12}>
                Antriebsart
                <FormGroup style={{ paddingTop: "8px" }}>
                  <FormControlLabel
                    classes={{ root: this.props.classes.label }}
                    control={
                      <Switch
                        color="primary"
                        checked={this.props.propulsion.includes("1")}
                        onChange={(e) =>
                          this.props.setFilter(
                            "propulsion",
                            e.target.name,
                            e.target.checked
                          )
                        }
                        name="1"
                      />
                    }
                    label={
                      <div style={{ display: "flex" }}>
                        <div>
                          <img
                            alt=""
                            src={`${process.env.PUBLIC_URL}/Wasser.png`}
                            className={this.props.classes.img}
                          />
                        </div>
                        <div>Wasser</div>
                        <div
                          style={{
                            fontSize: "13px",
                            lineHeight: "24px",
                            marginLeft: "4px",
                            fontStyle: "italic",
                          }}
                        >
                          ({this.filterCount("Antriebsart", "1")})
                        </div>
                      </div>
                    }
                  />
                  <FormControlLabel
                    classes={{ root: this.props.classes.label }}
                    control={
                      <Switch
                        color="primary"
                        checked={this.props.propulsion.includes("2")}
                        onChange={(e) =>
                          this.props.setFilter(
                            "propulsion",
                            e.target.name,
                            e.target.checked
                          )
                        }
                        name="2"
                      />
                    }
                    label={
                      <div style={{ display: "flex" }}>
                        <div>
                          <img
                            alt=""
                            src={`${process.env.PUBLIC_URL}/Motor.png`}
                            className={this.props.classes.img}
                          />
                        </div>
                        <div>Motor</div>
                        <div
                          style={{
                            fontSize: "13px",
                            lineHeight: "24px",
                            marginLeft: "4px",
                            fontStyle: "italic",
                          }}
                        >
                          ({this.filterCount("Antriebsart", "2")})
                        </div>
                      </div>
                    }
                  />
                  <FormControlLabel
                    classes={{ root: this.props.classes.label }}
                    control={
                      <Switch
                        color="primary"
                        checked={this.props.propulsion.includes("3")}
                        onChange={(e) =>
                          this.props.setFilter(
                            "propulsion",
                            e.target.name,
                            e.target.checked
                          )
                        }
                        name="3"
                      />
                    }
                    label={
                      <div style={{ display: "flex" }}>
                        <div>
                          <img
                            alt=""
                            src={`${process.env.PUBLIC_URL}/Wind.png`}
                            className={this.props.classes.img}
                            style={{ maxHeight: "20px", marginRight: "8px" }}
                          />
                        </div>
                        <div>Wind</div>
                        <div
                          style={{
                            fontSize: "13px",
                            lineHeight: "24px",
                            marginLeft: "4px",
                            fontStyle: "italic",
                          }}
                        >
                          ({this.filterCount("Antriebsart", "3")})
                        </div>
                      </div>
                    }
                  />
                  <FormControlLabel
                    classes={{ root: this.props.classes.label }}
                    control={
                      <Switch
                        color="primary"
                        checked={this.props.propulsion.includes("4")}
                        onChange={(e) =>
                          this.props.setFilter(
                            "propulsion",
                            e.target.name,
                            e.target.checked
                          )
                        }
                        name="4"
                      />
                    }
                    label={
                      <div style={{ display: "flex" }}>
                        <div>
                          <img
                            alt=""
                            src={`${process.env.PUBLIC_URL}/Dampf.png`}
                            className={this.props.classes.img}
                          />
                        </div>
                        <div>Dampf</div>
                        <div
                          style={{
                            fontSize: "13px",
                            lineHeight: "24px",
                            marginLeft: "4px",
                            fontStyle: "italic",
                          }}
                        >
                          ({this.filterCount("Antriebsart", "4")})
                        </div>
                      </div>
                    }
                  />
                  <FormControlLabel
                    classes={{ root: this.props.classes.label }}
                    control={
                      <Switch
                        color="primary"
                        checked={this.props.propulsion.includes("5")}
                        onChange={(e) =>
                          this.props.setFilter(
                            "propulsion",
                            e.target.name,
                            e.target.checked
                          )
                        }
                        name="5"
                      />
                    }
                    label={
                      <div style={{ display: "flex" }}>
                        <div>
                          <img
                            alt=""
                            src={`${process.env.PUBLIC_URL}/Muskelkraft.png`}
                            className={this.props.classes.img}
                          />
                        </div>
                        <div>Muskelkraft</div>
                        <div
                          style={{
                            fontSize: "13px",
                            lineHeight: "24px",
                            marginLeft: "4px",
                            fontStyle: "italic",
                          }}
                        >
                          ({this.filterCount("Antriebsart", "5")})
                        </div>
                      </div>
                    }
                  />
                  <FormControlLabel
                    classes={{ root: this.props.classes.label }}
                    control={
                      <Switch
                        color="primary"
                        checked={this.props.propulsion.includes("6")}
                        onChange={(e) =>
                          this.props.setFilter(
                            "propulsion",
                            e.target.name,
                            e.target.checked
                          )
                        }
                        name="6"
                      />
                    }
                    label={
                      <div style={{ display: "flex" }}>
                        <div>
                          <img
                            alt=""
                            src={`${process.env.PUBLIC_URL}/Unbekannt.png`}
                            className={this.props.classes.img}
                          />
                        </div>
                        <div>Unbekannt</div>
                        <div
                          style={{
                            fontSize: "13px",
                            lineHeight: "24px",
                            marginLeft: "4px",
                            fontStyle: "italic",
                          }}
                        >
                          ({this.filterCount("Antriebsart", "6")})
                        </div>
                      </div>
                    }
                  />
                </FormGroup>
              </Grid>
              <Grid item sm={4} xs={12}>
                Gebäude vorhanden
                <FormGroup style={{ paddingTop: "8px" }}>
                  <FormControlLabel
                    classes={{ root: this.props.classes.label }}
                    control={
                      <Switch
                        color="primary"
                        checked={this.props.exists.includes("1")}
                        onChange={(e) =>
                          this.props.setFilter(
                            "exists",
                            e.target.name,
                            e.target.checked
                          )
                        }
                        name="1"
                      />
                    }
                    label={
                      <div style={{ display: "flex" }}>
                        <div>ja</div>
                        <div
                          style={{
                            fontSize: "13px",
                            lineHeight: "24px",
                            marginLeft: "4px",
                            fontStyle: "italic",
                          }}
                        >
                          ({this.filterCount("GebäudeVorhanden", "1")})
                        </div>
                      </div>
                    }
                  />
                  <FormControlLabel
                    classes={{ root: this.props.classes.label }}
                    control={
                      <Switch
                        color="primary"
                        checked={this.props.exists.includes("3")}
                        onChange={(e) =>
                          this.props.setFilter(
                            "exists",
                            e.target.name,
                            e.target.checked
                          )
                        }
                        name="3"
                      />
                    }
                    label={
                      <div style={{ display: "flex" }}>
                        <div>teilweise</div>
                        <div
                          style={{
                            fontSize: "13px",
                            lineHeight: "24px",
                            marginLeft: "4px",
                            fontStyle: "italic",
                          }}
                        >
                          ({this.filterCount("GebäudeVorhanden", "3")})
                        </div>
                      </div>
                    }
                  />
                  <FormControlLabel
                    classes={{ root: this.props.classes.label }}
                    control={
                      <Switch
                        color="primary"
                        checked={this.props.exists.includes("2")}
                        onChange={(e) =>
                          this.props.setFilter(
                            "exists",
                            e.target.name,
                            e.target.checked
                          )
                        }
                        name="2"
                      />
                    }
                    label={
                      <div style={{ display: "flex" }}>
                        <div>nein</div>
                        <div
                          style={{
                            fontSize: "13px",
                            lineHeight: "24px",
                            marginLeft: "4px",
                            fontStyle: "italic",
                          }}
                        >
                          ({this.filterCount("GebäudeVorhanden", "2")})
                        </div>
                      </div>
                    }
                  />
                </FormGroup>
              </Grid>
            </Grid>
          ) : (
            "Filtermöglichkeiten werden geladen ..."
          )}
          <div style={{ marginTop: "10px", paddingBottom: "27px" }}>
            <Button
              variant="contained"
              onClick={() => this.props.toggleFilter(false)}
              className={this.props.classes.button}
            >
              Schließen
            </Button>
            <Button
              variant="outlined"
              onClick={this.props.resetFilter}
              className={this.props.classes.button}
              disabled={!mills}
            >
              Zurücksetzen
            </Button>
          </div>
        </Drawer>
      </div>
    );
  }
}

Filter.propTypes = {
  open: PropTypes.bool.isRequired,
  municipality: PropTypes.array.isRequired,
  propulsion: PropTypes.array.isRequired,
  exists: PropTypes.array.isRequired,
  mills: PropTypes.object.isRequired,
  setFilter: PropTypes.func.isRequired,
  resetFilter: PropTypes.func.isRequired,
  toggleFilter: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  open: state.settings.filter,
  municipality: state.mill.filter.municipality,
  propulsion: state.mill.filter.propulsion,
  exists: state.mill.filter.exists,
  mills: state.mill.mills,
});

export default connect(mapStateToProps, {
  setFilter,
  resetFilter,
  toggleFilter,
})(withStyles(styles, { withTheme: true })(Filter));
